import { useEffect, useState } from "react";
import CreateRecordButton from "./CreateRecordButton";

import { cloneDeep } from "lodash";
import TkPopCompleteProcessDialog from "../dialogTypes/TkPopCompleteProcessDialog ";

function TkPopProduceEndButton(props) {

    const { id, schema, onSelectMst, createButtonName, items, onSuccess, onFailure, customizeErrorMsgCallback, onDetailSuccess, onTrigger, ...others } = props;

    const [open, setOpen] = useState(false);

    const [lotInfo, setLotInfo] = useState();

    useEffect(() => {

        if (onSelectMst) {

            setLotInfo(() => {

                let selectMstData = cloneDeep(onSelectMst);
                let lotInfo = selectMstData;

                lotInfo.lotNo = selectMstData.resultLotNo;
                lotInfo.bopMaterialName = selectMstData.materialName;

                delete lotInfo.resultLotNo;
                delete lotInfo.materialName;

                return lotInfo
            });

        }

    }, [onSelectMst]);

    const onProductionCompleteSuccess = (msg) => {

        if (onSuccess) {
            onSuccess(msg);
        }

    }


    const onOpen = () => {

        setOpen(true);
        onTrigger(true)
    }

    const onClose = () => {

        setOpen(false)
        onTrigger(false)
    }

    const modifyUrlCallback = (url, id) => {

        if ( id === "ElectrodeProcessing" ) {

            return `${url}?${id}`;

        }

        return url;

    }

    return (
        <>
            <CreateRecordButton createButtonName={createButtonName} id={id + "-create-produceEnd-button"} onClick={onOpen} {...others} />
            <TkPopCompleteProcessDialog
                lotInfo={lotInfo}
                mode="edit"
                open={open}
                onClose={onClose}
                onSuccess={onProductionCompleteSuccess}
                onFailure={onFailure} 
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={(url) => modifyUrlCallback(url, id)}
            />
        </>
    )
}

export default TkPopProduceEndButton;